var _circle, _circle2, _circle3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEllipse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 362,
    height: 362,
    viewBox: "0 0 362 362",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 362,
    transform: "rotate(90)",
    fill: "#FBFBFB"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    r: 286,
    transform: "rotate(90)",
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    r: 219,
    transform: "rotate(90)",
    fill: "#F8F8F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipse);
export default __webpack_public_path__ + "static/media/ellipse.bbab1dc3d6a5edba2fda1e0270f00e8e.svg";
export { ForwardRef as ReactComponent };